import React, {Component} from "react";
import { registerReactApp, reactAppLoaded } from '../services/reactLoadTracker';
import PropTypes from "prop-types";
import * as api from "../services/api";
import InspirationItem from "../components/Favourites/InspirationItem";
import PaginationControl from "../components/Filter/PaginationControl";
import translate from "../services/translation";

export class ExcursionInspirationApp extends Component {

    static propTypes = {
        filter: PropTypes.object,
        excursionType: PropTypes.string
    }

    static initialLimit = 3;

    initialState = {
        filter: {...this.props.filter, limit: ExcursionInspirationApp.initialLimit, offset: 0},
        excursions: [],
        excursionsTotal: [],
        loading: false,
        excursionType: this.props.excursionType
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    loadMore = () => {
        const newFilter = {
            ...this.state.filter,
            limit: parseInt(this.state.filter.limit,10) + ExcursionInspirationApp.initialLimit,
            offset: parseInt(this.state.filter.offset,10) + ExcursionInspirationApp.initialLimit
        };

        this.setState({filter: newFilter}, () => {
            this.fetchExcursions(true);
        })
    };

    fetchExcursions = (append = false) => {
        this.setState({loading: true});

        api.getExcursionsByFilter(this.state.filter).then(
            response => {
                if(append) {
                    const newExcursions = this.state.excursions.concat(response.data);
                    this.setState({excursions: newExcursions});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({excursions: response.data});
                    } else {
                        this.setState({excursions: []});
                    }
                }
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            },
            error => {
                console.error(error.message);
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            }
        )
    };

    // just here to estimate the total excursions. not that good but BE says is to dangerous the work on the api
    fetchExcursionsTotal = (append = false) => {
        this.setState({loading: true});

        api.getExcursionsByFilter({...this.props.filter, limit: 100}).then(
            response => {
                if(append) {
                    const newExcursions = this.state.excursionsTotal.concat(response.data);
                    this.setState({excursionsTotal: newExcursions});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({excursionsTotal: response.data});
                    } else {
                        this.setState({excursionsTotal: []});
                    }
                }
                this.setState({loading: false});
            },
            error => {
                console.error(error.message);
                this.setState({loading: false});
            }
        )
    };

    componentDidMount() {
        registerReactApp();
        this.fetchExcursionsTotal();
        this.fetchExcursions();
    }

    render() {
        const {excursions, loading, excursionType, excursionsTotal} = this.state;

        return (
            <div className="itineraryExcursionInspiration">
                {excursionType === 'optional' && <h3>{translate('itinerary_show_ideas_title')}</h3>}
                {excursionType === 'inspiration' && <h3>{translate('itinerary_show_inspirations_title')}</h3>}

                <div className="itineraryExcursionsList">
                    {excursions && excursions.map(excursion => <InspirationItem key={excursion.uid} excursion={excursion}/>) }
                </div>

                {excursions.length === 0 && !loading &&
                    <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div>
                }

                {excursionsTotal.length > 3 && excursions.length === parseInt(this.state.filter.limit,10) ?
                    <PaginationControl paginate={this.loadMore} /> : ''
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/apps/ExcursionInspirationApp.js